import React from 'react';
import { Link } from 'react-router-dom';

const FooterLogo = () => (
  <div className="w-14 h-14 relative flex items-center justify-center">
    <div className="absolute inset-0 rotate-45 border-2 border-white/80 rounded-sm" />
    <div className="absolute inset-1 rotate-45 border border-white/40 rounded-sm" />
    <span className="relative text-white font-serif text-base font-semibold tracking-wide">PL</span>
  </div>
);

export default function Footer() {
  const handleScroll = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    else window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#1a1a1a] text-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 pb-12">
          <div>
            <FooterLogo />
            <p className="text-white/60 text-sm mt-6">www.patagonialobby.com</p>
            <p className="text-white/70 text-sm mt-4 leading-relaxed max-w-sm">
              Plataforma estratégica de comercio internacional. Centralizamos solicitudes de
              cotización y proyectos de importación, exportación e internacionalización
              empresarial.
            </p>
          </div>

          <div className="md:pl-8">
            <h4 className="text-white font-semibold text-sm tracking-wide mb-5">Servicios</h4>
            <ul className="space-y-3 text-white/70 text-sm">
              <li><Link to="/solicitar?servicio=importacion" className="hover:text-white transition-colors">Importación</Link></li>
              <li><Link to="/solicitar?servicio=exportacion" className="hover:text-white transition-colors">Exportación</Link></li>
              <li><Link to="/solicitar?servicio=internacionalizacion" className="hover:text-white transition-colors">Internacionalización</Link></li>
              <li><Link to="/solicitar?servicio=modelo" className="hover:text-white transition-colors">Modelos de Negocio</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm tracking-wide mb-5">Plataforma</h4>
            <ul className="space-y-3 text-white/70 text-sm">
              <li><button onClick={() => handleScroll('servicios')} className="hover:text-white transition-colors">Servicios</button></li>
              <li><button onClick={() => handleScroll('proceso')} className="hover:text-white transition-colors">Proceso</button></li>
              <li><button onClick={() => handleScroll('sectores')} className="hover:text-white transition-colors">Sectores</button></li>
              <li><Link to="/solicitar" className="hover:text-white transition-colors">Solicitar Cotización</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-10">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
            <a
              href="https://www.grupoconsa.cl"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-3 group w-fit"
            >
              <span className="shrink-0 w-10 h-10 rounded-full bg-white flex items-center justify-center overflow-hidden">
                <img
                  src="https://customer-assets.emergentagent.com/job_lobby-contact-portal/artifacts/tpgm96l2_Logo%20CONSA%20PNG.png"
                  alt="CONSA"
                  className="w-8 h-8 object-contain"
                />
              </span>
              <div className="leading-tight">
                <div className="text-[9px] tracking-[0.28em] uppercase text-white/50 font-medium">
                  Agente Comercial Oficial
                </div>
                <div className="text-white/85 text-xs font-semibold tracking-wide group-hover:text-white transition-colors">
                  CONSA · Consorcio Salinero del Tarapacá S.A.
                </div>
              </div>
            </a>
            <p className="text-white/50 text-sm">© 2026 Patagonia Lobby. Todos los derechos reservados.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
